import type { CardDefinition } from "../domain/types/index.js";

export const POOL_EXPANSION_CARDS = {
  "workers-village": {
    id: "workers-village", name: "現場監督", type: "action",
    text: "1枚引く。行動+2。防御+1", rewardTier: "medium",
    effect: {
      kind: "compound",
      effects: [
        { kind: "drawAction", draw: 1, actions: 2 },
        { kind: "block", amount: 1 },
      ],
    },
  },
  villa: {
    id: "villa", name: "現場裁量", type: "action",
    text: "行動+2。防御+1。進捗+1", rewardTier: "medium",
    effect: {
      kind: "compound",
      effects: [
        { kind: "drawAction", draw: 0, actions: 2 },
        { kind: "block", amount: 1 },
        { kind: "progress", amount: 1 },
      ],
    },
  },
  stables: {
    id: "stables", name: "他件対応", type: "action",
    text: "労働者1枚を捨て、3枚引く。行動+1", rewardTier: "medium",
    effect: { kind: "stables" },
  },
  inn: {
    id: "inn", name: "方針整理", type: "action",
    text: "2枚引く。行動+2。2枚捨てる", rewardTier: "medium",
    effect: {
      kind: "compound",
      effects: [
        { kind: "draw", count: 2 },
        { kind: "drawAction", draw: 0, actions: 2 },
        { kind: "inn" },
      ],
    },
  },
  bazaar: {
    id: "bazaar", name: "PJ推進", type: "action",
    text: "1枚引く。行動+2。進捗+1", rewardTier: "large",
    effect: {
      kind: "compound",
      effects: [
        { kind: "drawAction", draw: 1, actions: 2 },
        { kind: "progress", amount: 1 },
      ],
    },
  },
  "lost-city": {
    id: "lost-city", name: "体制構築", type: "action",
    text: "2枚引く。行動+2", rewardTier: "large",
    effect: { kind: "drawAction", draw: 2, actions: 2 },
  },
  "city-quarter": {
    id: "city-quarter", name: "横展開", type: "action",
    text: "行動+2。手札の施策1枚につき1枚引く", rewardTier: "large",
    effect: {
      kind: "compound",
      effects: [
        { kind: "drawAction", draw: 0, actions: 2 },
        { kind: "drawPerAction" },
      ],
    },
  },
  "kings-court": {
    id: "kings-court", name: "取締役会", type: "action",
    text: "手札の施策1枚を選び、3回使用する", rewardTier: "large",
    effect: { kind: "meeting", times: 3 },
  },
} as const satisfies Record<string, CardDefinition>;
